import {
    USER_LOGIN,
} from '../types'

let state = {
    didLogin: false,
    user: {}
}

const mutations = {
    [USER_LOGIN](state, user) {
        if (!!user) {
            state.user = user;
        }
        state.didLogin = !!user;
    },
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js